@if (errorText()) {
<div class="invalid-fields-inline">
  <h3 class="error">{{ errorText() }}</h3>
  <app-invalid-field-badges
    [invalidFields]="invalidFields()"
    (fieldSelected)="onFieldSelected($event)" />
</div>
}
